import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from "@material-ui/core";
import React from "react";
import { useHistory } from "react-router-dom";
import { updateRegistrationSearched } from "../Base/Services/RegistrationService";

export default function AdminNoMatchDialog({ open, onClose, registrationId }) {
  const history = useHistory();

  function handleConfirmRecord() {
    updateRegistrationSearched(registrationId).then(() => history.push("/admin"));
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={() => {
          onClose();
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to mark this record as searched?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="default">
            Cancel
          </Button>
          <Button color="primary" autoFocus onClick={handleConfirmRecord}>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
